var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeuxiemePersonnage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 3000 3000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fbbcaa;}.cls-2{fill:#173856;}.cls-3{fill:#20456e;}.cls-4{fill:#82cec4;}.cls-5{fill:#442114;}.cls-6{fill:none;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "deuxi\xE8me personnage") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "personnages"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2776.25,1873.81s-13.47-312.08,6.73-381.68,39.3-259.33,55-344.64c0-134.72-95.87-302-206.56-346.89-130.22-52.76-290.75-40.41-368.21,26.94S2140.85,987,2138.61,1039.72s-23,467.19-5,507.6,32.55,43.78,65.11,47.15,159.92,29,159.92,29L2371,1873.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1877,3000l-197-480.52S1695,2308,1773,2249s219,59,219,59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M3000,1823c-84.18-32.77-224.87-78.29-224.87-78.29s13.47,46-30.31,66.24-317.7,33.67-354.75,19.08-20.2-30.31-20.2-30.31-195.34,23.57-253.71,57.25-112.26,70.73-132.47,128S1836,3000,1836,3000H3000S2998,1866,3000,1823Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2838,1784c-18,40.42-174,101-287.38,89.81s-233.51-15.71-253.71-38.17-25.07-21.16-25.07-21.16,29.56-79.87,67.73-91.1,108.89,20.21,227.88,35.93c26.81,3.54,233.51,7.85,204.46-68.38C2792,1705.42,2856,1743.59,2838,1784Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M2194,1172c0,30-7,35,34,76,0-64,40-61,76-57s27,131,0,160,85,60,139,96,108.79,112,112.89,155.51c73.11,8.49,216.8,0,216.8,0S2881,1114,2872,1069s-56-193-123-247-149.92-108-248-108c-135,0-340,55-391,159s-38,161-11,161,79-32,79-32-27,79-16,104S2194,1142,2194,1172Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "2130.1 3000 2203 2389 2166.55 3000 2130.1 3000"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Calque_3",
    "data-name": "Calque 3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    width: 3000,
    height: 3000
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeuxiemePersonnage);
export default __webpack_public_path__ + "static/media/deuxieme_personnage.4ff2b92325aa8f3dc940934ff35260b3.svg";
export { ForwardRef as ReactComponent };